import styled from "styled-components";

const Wrapper = styled.main`
  .sidebar_and_outlet {
    display: flex;
  }
`;

export default Wrapper;
